import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { Button, DatePicker, Dialog, Form, Icon, Input, Select, Switch, Tab, Table,Balloon} from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import { Servlets } from '@/service';
import { useHistory } from 'react-router-dom';
import icon_helpCourse from '@/pages/CrowdMarketing/icon/icon-helpCourse.svg';
import moment from 'moment';
import utils from '@/common/utils';
import LzMsg from '@/components/common/LzMsg';
import { Item } from '@alifd/next/types/breadcrumb';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';

const OrderPaymentList = (props) => {
  const FormItem = Form.Item;
  const { Tooltip } = Balloon;
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const history = useHistory();

  // 确认删除dialog
  const [deleteMission, setDeleteMission] = useState(false);
  // 催付记录dialog
  const [paymentRecord, setPaymentRecord] = useState(false);
  // 当前被点击催付记录的任务id
  const [currentId, setCurrentId] = useState(0);
  // 任务列表分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 一次催付分页数据
  const [firstPageInfo, setFirstPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 二次催付分页数据
  const [secondPageInfo, setSecondPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 列表数据
  const [tableList, setTableList] = useState([]);
  // 列表查询参数
  const [listParams, setListParams] = useState({
    name: '',
    startTime: '',
    endTime: '',
    pageNo: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
  });
  // 列表loading
  const [listLoading, setListLoading] = useState(false);
  // 临时列表数据
  const [tableData, setTableData] = useState([
    {
      startTime: 1604805246804,
      endTime: 1604805246804,
      taskActive: true, // 状态是否开启
      taskName: '测试任务',
      taskPriority: 1, // 任务优先级
      orderCondition: { // 催付条件
        amount: '30-256', // 催付金额
        skuNum: '2-4', // 商品数量
        skus: {
          type: 2, // 催付商品：全部商品1(ids为空)，指定为2，排除是3
          ids: [// 指定或排除的商品
            123123,
            12314,
            23425,
            24234,
          ],
        },
        area: { // 催付地区
          type: 2, // 不限1(ids空)，指定地区2，排除3
          ids: [
            '1,1221,332', // 省市县区(类似结构)
            '2,33,1112',
          ],
        },
      },
      sendingCondition: { // 发送时段
        delay: 300000, // 催付条件 下单xxx时间后未付款
        durations: {
          type: 1, // 不限制时间段：1(spans为空),指定时间段：2
          spans: [
            '10-19', // 发送时间段
            '20-23',
          ],

        },
        oncePerDay: true, // 过滤条件
        quantityLimit: 10000, // 限制条件
      },
      smsContent: { // 列表短信
        templateId: '222',
        sign: '陆泽测试店铺',
        content: '短信内容',
      },
      secondary: { // 二次催付
        taskActive: true, // 是否开启
        sendingCondition: { // 催付条件，转毫秒
          delay: 30000,
        },
        smsContent: { // 通过短信模板dialog选择出的数据
          templateId: '222',
          sign: '陆泽测试店铺',
          content: '二次短信内容',
        },
      },
    },
  ]);
  // 删除id
  const [deleteId, setDeleteId] = useState();

  // 一次催付记录列表
  const [firstRecord, setFirstRecord] = useState([]);
  // 一次loading
  const [firstLoading, setFirstLoading] = useState(false);
  // 二次催付记录列表
  const [secondRecord, setSecondRecord] = useState([]);
  // 二次loading
  const [secondLoading, setSecondLoading] = useState(false);
  // 任务列表所点的任务数据
  let [missionRecord, setMissionRecord] = useState({});
  // 一次催付当前查询的数据(保存上一次的请求参数便于用于导出效果数据)
  const [currentData, setCurrentData] = useState({});
  // 二次催付当前查询的数据(保存上一次的请求参数便于用于导出效果数据)
  const [secondCurrentData, setSecondCurrentData] = useState({});
  // 一次催付总数
  const [firstPaymentNum, setFirstPaymentNum] = useState({
    ordersCount: 0,
    smsCount: 0,
  });
  // 二次催付总数
  const [secondPayment, setSecondPayment] = useState({
    ordersCount: 0,
    smsCount: 0,
  });

  // 列表查询
  const listFetch = (v) => {
    setListParams({
      name: v.projectNameInput ? v.projectNameInput : '',
      startTime: v.projectSetTime && v.projectSetTime.length !== 0 ? moment(v.projectSetTime[0]._d).format('x') : '',
      endTime: v.projectSetTime && v.projectSetTime.length !== 0 ? moment(v.projectSetTime[1]._d).format('x') : '',
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    });
    getPayList({
      name: v.projectNameInput ? v.projectNameInput : '',
      startTime: v.projectSetTime && v.projectSetTime.length !== 0 ? moment(v.projectSetTime[0]._d).format('x') : '',
      endTime: v.projectSetTime && v.projectSetTime.length !== 0 ? moment(v.projectSetTime[1]._d).format('x') : '',
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    });
  };

  // 页面变化触发
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      getPayList({
        // listParams
        name: listParams.name,
        startTime: listParams.startTime,
        endTime: listParams.endTime,
        pageNo: pages.pageNo,
        pageSize: pages.pageSize,
      });
    } catch (e) {
    }
  };
  // 一次催付页面变化触发
  const firstSizeChange = async (pages = {}) => {
    try {
      setFirstPageInfo({
        ...pageInfo,
        ...pages,
      });
      const tempParams = { ...currentData };
      tempParams.pageNo = pages.pageNo;
      tempParams.pageSize = pages.pageSize;
      tempParams.taskId = currentId;
      firstRecordCheck(tempParams);
    } catch (e) {
    }
  };
  // 二次催付页面变化触发
  const secondSizeChange = async (pages = {}) => {
    try {
      setSecondPageInfo({
        ...pageInfo,
        ...pages,
      });
      const tempParams = { ...secondCurrentData };
      tempParams.pageNo = pages.pageNo;
      tempParams.pageSize = pages.pageSize;
      tempParams.taskId = currentId;
      secondRecordCheck(tempParams);
    } catch (e) {
    }
  };

  /**
   * 重置
   */
  const handleReset = () => {
    setListParams({
      name: '',
      startTime: '',
      endTime: '',
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    });
    getPayList({ pageNo: 1, pageSize: 10 });
  };

  // 开始时间，结束时间换行显示
  const getDate = (value, index, item) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <span>{item.time.toString().substring(0, 5)}</span>
        <span>{item.time.toString().substring(5, 24)}</span>
        <span>{item.time.toString().substring(24, 29)}</span>
        <span>{item.time.toString().substring(29, 48)}</span>
      </div>
    );
  };

  // 请求催付列表数据
  const getPayList = (params) => {
    setListLoading(true);
    Servlets('getPaymentList', params).then((res) => {
      res.data.forEach((item, index) => {
        if (Number(item.endTime) < 3155673600000) {
          item.time = `开始时间：${moment(item.startTime).format('YYYY-MM-DD HH:mm:ss')}结束时间：${moment(item.endTime).format('YYYY-MM-DD HH:mm:ss')}`;
        } else {
          item.time = '无限制';
        }
      });
      setTableList(res.data);
      setListLoading(false);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
    })
      .catch(() => {
      });
  };

  // 删除催付列表数据
  const deletePayList = (id) => {
    Servlets('deletePaymentList', { taskId: id }).then((res) => {
      getPayList({
        pageNo: 1,
        pageSize: pageInfo.pageSize,
      });
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
    })
      .catch(() => {
      });
  };

  // 一次获取催付订单数和短信总量
  const getFirstSmsAccount = (params) => {
    Servlets('getPaymentAmount', params).then((res) => {
      const temp = res.data;
      temp.ordersCount = res.data.ordersCount;
      temp.smsCount = res.data.smsCount;
      setFirstPaymentNum(temp);
    });
  };
  // 二次获取催付订单数和短信总量
  const getSecondSmsAccount = (params) => {
    Servlets('getPaymentAmount', params).then((res) => {
      const temp = res.data;
      temp.ordersCount = res.data.ordersCount;
      temp.smsCount = res.data.smsCount;
      setSecondPayment(temp);
    });
  };
  // 一次催付记录
  // 一次记录列表查询
  const firstRecordCheck = (params) => {
    Servlets('getPaymentRecordList', params).then((res) => {
      setFirstLoading(true);
      const tempResult = res.data;
      tempResult.forEach((item, index) => {
        item.type = '订单催付';
        if (Number(item.sendStatus) === 1) {
          item.sendStatus = '发送成功';
        } else if (Number(item.sendStatus) === 0) {
          item.sendStatus = '发送失败';
        }
        item.smsWordsNum = `${item.smsWordsNum}/${item.smsNum}`;
        item.sendTime = moment(item.sendTime).format('YYYY-MM-DD HH:mm:ss');
      });
      setFirstRecord(tempResult);
      setFirstPageInfo({
        ...firstPageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setFirstLoading(false);
    });
  };
  // 二次催付记录(走的是一个接口，参数不同)
  const secondRecordCheck = (params) => {
    Servlets('getPaymentRecordList', params).then((res) => {
      // console.log(res, '催付二次');
      setSecondLoading(true);
      const tempResult = res.data;
      tempResult.forEach((item, index) => {
        item.type = '订单催付';
        if (item.sendStatus === 1) {
          item.sendStatus = '发送成功';
        } else if (item.sendStatus === 0) {
          item.sendStatus = '发送失败';
        }
        item.smsWordsNum = `${item.smsWordsNum}/${item.smsNum}`;
        item.sendTime = moment(item.sendTime).format('YYYY-MM-DD HH:mm:ss');
      });
      setSecondRecord(tempResult);
      setSecondPageInfo({
        ...secondPageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setSecondLoading(false);
    });
  };

  // 催付记录导出
  const exportRecord = (params) => {
    Servlets('getRecordExcelout', params).then((res) => {
      utils.downloadFile(res);
    });
  };

  useEffect(() => {
    // 请求催付列表数据
    getPayList({
      pageNo: 1,
      pageSize: pageInfo.pageSize,
    });
  }, []);

  // 表格里的状态栏
  const status = (value, index, record) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Switch
          checked={record.taskActive}
          onClick={() => {
            // 修改taskActive布尔值
            const tempArr = [...tableList];
            tempArr[index].taskActive = !tempArr[index].taskActive;
            setTableList(tempArr);
            Servlets('switchMission', {
              activation: tempArr[index].taskActive,
              taskId: record.id,
            });
          }}
        />
        {
          record.taskActive
            ?
              <span style={{ lineHeight: '30px', paddingLeft: '10px', height: '30px' }}>已开启</span>
            :
              <span style={{ lineHeight: '30px', paddingLeft: '10px', height: '30px' }}>已关闭</span>
        }
      </div>
    );
  };

  // 表格里的操作栏
  const oprate = (value, index, record) => {
    return (
      <div className={styles.operating}>
        {/* 1 新建 2 查看 3 修改 */}
        <Button
          type="primary"
          text
          onClick={() => {
            history.push('/order/mission', { pageStatus: 2, info: record });
          }}
          style={{ color: '#3399FF' }}
        >查看
        </Button>
        <Button
          type="primary"
          style={{ color: '#3399FF' }}
          text
          onClick={() => {
            history.push('/order/mission', { pageStatus: 3, info: record });
          }}
        >修改
        </Button>
        <Button
          type="primary"
          style={{ color: '#3399FF' }}
          text
          onClick={() => {
            setDeleteMission(true), setDeleteId(record.id);
          }}
        >删除
        </Button>
        <Button
          type="primary"
          style={{ color: '#3399FF' }}
          text
          onClick={() => {
            setPaymentRecord(true), setMissionRecord(record);
            setCurrentId(record.id);
            getFirstSmsAccount({
              taskId: record.id,
              taskType: 'S_CFTX',
            });
            getSecondSmsAccount({
              taskId: record.id,
              taskType: 'S_CFT2',
            });
            missionRecord = record;
            setMissionRecord(record);
            // 请求一次催付
            firstRecordCheck({
              pageNo: 1,
              pageSize: 10,
              taskId: record.id,
              taskType: 'S_CFTX',
            });

            // 设置初始页面数据的请求参数
            const tempCurrent = {
              pageNo: 1,
              pageSize: 10,
              taskId: record.id,
              taskType: 'S_CFTX',
            };
            setCurrentData(tempCurrent);

            const tempSecondCurrent = {
              pageNo: 1,
              pageSize: 10,
              taskId: record.id,
              taskType: 'S_CFT2',

            };
            setSecondCurrentData(tempSecondCurrent);
            // 请求二次催付
            secondRecordCheck({
              pageNo: 1,
              pageSize: 10,
              taskId: record.id,
              taskType: 'S_CFT2',
            });
          }}
        >任务记录
        </Button>
      </div>
    );
  };

  // 改下拉菜单为上拉
  const popupProps = { align: 'bl tl' };

  return (
    <div>

      <div className={styles.warning}>
        {/* <span className={"iconfont icon-icon4-37"} style={{ fontSize: "16px", textAlign: "center", paddingRight: "5px", color: "#3399FF" }}></span> */}
        <div className={styles.item}>
          <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
          <span>提示：自动通知买家对产品支付货款，有效提高订单的付款率。如更改设置，新设置只对保存设置后产生的订单生效。</span>
        </div>

        {/* <div className={styles.item}>
          <span>催付秘籍</span>
          <img src={icon_helpCourse} alt="催付秘籍" style={{ width: 12, height: 12, marginLeft: 4 }} />
        </div> */}
      </div>
      {/* <div className={styles.checkInput}>
        <Form>
          <div className={styles.inputBox}>
            <div className={styles.con}>
              <FormItem >
                <p>任务名称：</p>
                <Input
                  placeholder="请输入"
                  aria-label="Medium"
                  aria-labelledby="J_InputMedium"
                  style={{ width: "90%", marginTop: "10px" }}
                  name="projectNameInput" />
              </FormItem >
            </div>
            <div className={styles.con}>
              <FormItem >
                <p>创建时间：</p>
                <RangePicker
                  className={styles.datePicker}
                  format="YYYY-MM-DD"
                  style={{ marginTop: "10px", width: "90%" }}
                  followTrigger={true}
                  name="projectSetTime"
                  showTime={{ format: 'HH:mm:ss' }} />
              </FormItem>
            </div>
            <div className={styles.CheckButtonBox} style={{ flex: 1 }}>
              <FormItem>
                <div style={{ display: "flex" }}>
                  <Form.Submit validate type="primary" onClick={(v, e) => { listFetch(v) }} style={{ marginRight: 10 }}>查询</Form.Submit>
                  <Form.Reset onClick={() => {
                    getPayList({
                      pageNo: 1,
                      pageSize: 10
                    })
                  }}>重置</Form.Reset>
                </div>
              </FormItem>
            </div>
          </div>
        </Form>
      </div> */}

      <div className={styles.listSearch}>

        <Form inline className={styles.listSearchForm} size="medium">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <FormItem className={styles.formItem} style={{ flex: '1' }}>
              <span>任务名称：</span>
              <Input
                name="projectNameInput"
                className={styles.formItem_width}
                placeholder="请输入..."
                maxLength={100}
                hasClear
              />
            </FormItem>
            <FormItem className={styles.formItem} style={{ flex: '1' }}>
              <span>创建时间：</span>
              <RangePicker
                popupAlign="tl tl"
                className={styles.formItem_width}
                format="YYYY-MM-DD"
                name="projectSetTime"
                showTime={{ format: 'HH:mm:ss' }}
                followTrigger
              />
            </FormItem>

            <FormItem label="" className={styles.formItem} style={{ flex: '1', textAlign: 'right' }}>

              <Form.Submit
                type="primary"
                onClick={(v, e) => {
                  listFetch(v);
                }}
                style={{ marginRight: 10 }}
                className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`}
              >查询
              </Form.Submit>

              <Form.Reset
                className={`${styles.submitBtnStyle_width}`}
                onClick={handleReset}
              >重置
              </Form.Reset>
            </FormItem>
          </div>
        </Form>

      </div>
      <div className={styles.orderTable}>
        <div style={{ textAlign: 'right', paddingBottom: '18px' }}>
          <Button
            type="primary"
            className={styles.newMission}
            onClick={() => {
              history.push('/order/mission', { pageStatus: 1 });
            }}
          >+新建催付任务
          </Button>
        </div>

        <Table dataSource={tableList} loading={listLoading}>
          <Table.Column title="任务名称" dataIndex="taskName" width="160px" align="left" />
          <Table.Column title="短信内容" dataIndex="smsContent.content" width="210px" align="left" />
          <Table.Column title="创建时间" width="160px" align="left" cell={(value, index, item) => {
            return (
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <span>{moment(item.updateTime).format("YYYY-MM-DD hh:mm:ss")}</span>
              </div>
            );
          }} />
          <Table.Column title="任务时间" width="160px" align="left" cell={getDate} />
          {/* <Table.Column title="执行日志" dataIndex="endTime" width="150px" align="left" 
          /> */}
          <Table.Column 
                    title={
                        <div>
                            <span>优先级</span>
                            <Tooltip align="t" trigger={<span style={{ fontSize: "14px", marginLeft: "4px", cursor: "pointer" }} className={`iconfont icon-icon4-33`}></span>}>
                            说明<br/>
                            1.同一订单满足多条已开启任务时，只按照优先级最高的任务执行。可单击修改调整优先级，数字越小优先级越高。<br/>
                            2.同一订单满足多条优先级相同任务时，只按照发送时间最早的任务执行。
                            </Tooltip>
                        </div>
                        } 
                        dataIndex="taskPriority" align='left' width="90px" />
          <Table.Column title="状态" cell={status} width="150px" align="left" />
          <Table.Column title="操作" width="200px" cell={oprate} align="left" lock="right" />
        </Table>

        <div style={{ paddingRight: '20px' }}>
          <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
        </div>
      </div>

      {/* 删除任务dialog */}
      { deleteMission &&
        <ConfirmDialog
          promptInfo='删除任务后，相关任务发送记录只可以在记录汇总内查询，是否确认删除'
          title="提示"
          flag={deleteMission}   
          confirmHandel={() => {
            setDeleteMission(false);
            deletePayList(deleteId);
          }}
          cancelHandel={() => {
            setDeleteMission(false);
          }}
        />
      }
      {/* 催付记录dialog */}
      {
        paymentRecord &&
        <Dialog
          footer={false}
          visible={paymentRecord}
          onClose={() => {
            setPaymentRecord(false);
          }}
          className={styles.peopleDialogContainer}
          shouldUpdatePosition={true}
          title={
            <div className={styles.testTitle} style={{ background: '#F5F7F9' }}>
              催付记录
              <div className={styles.dialogClose} onClick={() => {setPaymentRecord(false);}}>×</div>
            </div>
          }
        >
          <div >
            <div
              className={styles.newCopyCon}
              style={{
                width: `${document.documentElement.clientWidth * 0.7 }px`,
                overflowY: 'auto',
              }}
            >
              <div className="recordTab">
                <Tab shape="capsule" className={'tab-content'}>
                  {/* 一次催付 */}
                  <Tab.Item title="一次催付" key="orderPayment">
                    <div>
                      <div className={styles.recordTitle}>
                        <div className={styles['top-left-box']}>
                          <div>任务名称：{missionRecord.taskName ? missionRecord.taskName : ''}</div>
                          <div>短信内容：{Object.values(missionRecord).length > 0 ? missionRecord.smsContent.content : ''}</div>
                          <div style={{ paddingRight: '30px' }}>一次催付总数：<span
                            className={styles.mustFill}
                          >{firstPaymentNum.ordersCount}
                          </span> 单
                          </div>
                          <div>已成功发送短信：<span
                            className={styles.mustFill}
                          >{firstPaymentNum.smsCount}
                          </span> 条
                          </div>
                        </div>
                        <div className={styles['top-right-box']}>
                          <Button
                            type="primary"
                            onClick={() => {
                              if (firstRecord.length > 0) {
                                exportRecord(currentData);
                              } else {
                                LzMsg.error('数据为空，无法导出');
                              }
                            }}
                          >导出
                          </Button>
                        </div>
                      </div>
                      <div className={styles.checkInput} style={{ marginBottom: '10px' }}>
                        <Form>
                          <div className={styles.inputBox}>
                            <div className={styles.con}>
                              <FormItem>
                                <p>发送时间：</p>
                                <RangePicker
                                  popupAlign="tl tl"
                                  className={styles.datePicker}
                                  format="YYYY-MM-DD"
                                  // style={{width:100+"%"}}
                                  style={{ marginTop: '20px', width: '95%' }}
                                  followTrigger
                                  name="sendTime"
                                  showTime={{ format: 'HH:mm:ss' }}
                                />
                              </FormItem>
                            </div>
                            <div className={styles.con}>
                              <FormItem>
                                <p>订单号：</p>
                                <Input
                                  placeholder="请输入"
                                  aria-label="Medium"
                                  aria-labelledby="J_InputMedium"
                                  style={{ width: '95%', marginTop: '20px' }}
                                  name="orderId"
                                />
                              </FormItem>
                            </div>
                            <div className={styles.con}>
                              <FormItem>
                                <p>发送状态：</p>
                                <Select
                                  id="basic-demo"
                                  defaultValue="all"
                                  style={{ marginTop: '20px', width: '95%' }}
                                  aria-label="name is"
                                  name="sendStatus"
                                  className={styles.select}
                                  followTrigger
                                  // popupProps={popupProps}
                                >
                                  <Option value="all">全部</Option>
                                  <Option value="1">发送成功</Option>
                                  <Option value="0">发送失败</Option>
                                </Select>
                              </FormItem>
                            </div>
                          </div>
                          <div className={styles.CheckButtonBox} style={{ flex: 1 }}>
                            <FormItem>
                              <div style={{ display: 'flex' }}>
                                <Form.Submit
                                  validate
                                  type="primary"
                                  onClick={(v, e) => {
                                    let tempCurrent = currentData;
                                    tempCurrent = {
                                      pageNo: 1,
                                      pageSize: 10,
                                      taskId: currentId,
                                      taskType: 'S_CFTX',
                                      startTime: v.sendTime && v.sendTime.length !== 0 ? v.sendTime[0]._d.getTime() : '',
                                      endTime: v.sendTime && v.sendTime.length !== 0 ? v.sendTime[1]._d.getTime() : '',
                                      orderId: v.orderId,
                                      sendStatus: v.sendStatus === 'all' ? '' : v.sendStatus,
                                    };
                                    setCurrentData(tempCurrent);
                                    firstRecordCheck(tempCurrent);
                                  }}
                                  style={{ marginRight: 10 }}
                                >查询
                                </Form.Submit>
                                <Form.Reset onClick={() => {
                                  firstRecordCheck({
                                    pageNo: 1,
                                    pageSize: 10,
                                    taskId: currentId,
                                    taskType: 'S_CFTX',
                                  });
                                  setCurrentData({
                                    pageNo: 1,
                                    pageSize: 10,
                                    taskId: currentId,
                                    taskType: 'S_CFTX',
                                    startTime:  '',
                                    endTime: '',
                                    sendStatus: '',
                                  })
                                }}
                                >重置
                                </Form.Reset>
                              </div>
                            </FormItem>
                          </div>
                        </Form>
                      </div>
                      {/* 催付记录表格 */}
                      <div>
                        <Table dataSource={firstRecord} loading={firstLoading} fixedHeader>
                          <Table.Column title="发送时间" dataIndex="sendTime" align="left" />
                          <Table.Column title="订单号" dataIndex="orderId" align="left" />
                          <Table.Column
                            title="字数/计费（条)"
                            dataIndex="smsWordsNum"
                            align="left"
                            cell={(value) => {
                              return (<span>{value.slice(0, value.length - 1)}<span
                                className={styles.mustFill}
                              >{value.slice(value.length - 1)}
                              </span>
                              </span>);
                            }}
                          />
                          <Table.Column
                            title="发送状态"
                            dataIndex="sendStatus"
                            align="left"
                            cell={(value) => {
                              if (value === '发送成功') {
                                return (<div
                                  style={{ color: '#00BB66' }}
                                >{value}
                                </div>);
                              } else if (value === '发送失败') {
                                return (<div
                                  style={{ color: '#FF3333' }}
                                >{value}
                                </div>);
                              }
                            }}
                          />
                          <Table.Column title="催付类型" dataIndex="type" align="left" />
                          <Table.Column 
                            title="备注" 
                            align="left" 
                            cell={(item,value,index)=>(
                              <span>{item.remark?item.remark:'--'}</span>
                            )} 
                          />
                        </Table>
                      </div>
                      <div style={{}}>
                        <LzPagination pageInfo={firstPageInfo} onChange={firstSizeChange} />
                      </div>
                    </div>
                  </Tab.Item>
                  <Tab.Item title="二次催付" key="paymentRecord">
                    <div>
                      <div className={styles.recordTitle}>
                        <div className={styles['top-left-box']}>
                          <div>任务名称：{missionRecord.taskName ? missionRecord.taskName : ''}</div>
                          <div>短信内容：{Object.values(missionRecord).length > 0 ? missionRecord.secondary.smsContent.content : ''}</div>
                          <div style={{ paddingRight: '30px' }}>二次催付总数：<span
                            className={styles.mustFill}
                          >{secondPayment.ordersCount}
                          </span> 单
                          </div>
                          <div>已成功发送短信：<span
                            className={styles.mustFill}
                          >{secondPayment.smsCount}
                          </span> 条
                          </div>
                        </div>
                        <div className={styles['top-right-box']}>
                          <Button
                            type="primary"
                            onClick={() => {
                              if (secondRecord.length > 0) {
                                exportRecord(secondCurrentData);
                              } else {
                                LzMsg.error('数据为空，无法导出');
                              }
                            }}
                          >导出
                          </Button>
                        </div>
                      </div>
                      <div className={styles.checkInput} style={{ marginBottom: '10px' }}>
                        <Form>
                          <div className={styles.inputBox}>
                            <div className={styles.con}>
                              <FormItem>
                                <p>发送时间：</p>
                                <RangePicker
                                  popupAlign="tl tl"
                                  className={styles.datePicker}
                                  format="YYYY-MM-DD"
                                  style={{ marginTop: '20px', width: '95%' }}
                                  followTrigger
                                  name="sendTime"
                                  showTime={{ format: 'HH:mm:ss' }}
                                />
                              </FormItem>
                            </div>
                            <div className={styles.con}>
                              <FormItem>
                                <p>订单号：</p>
                                <Input
                                  placeholder="请输入"
                                  aria-label="Medium"
                                  aria-labelledby="J_InputMedium"
                                  style={{ width: '95%', marginTop: '20px' }}
                                  name="orderId"
                                />
                              </FormItem>
                            </div>
                            <div className={styles.con}>
                              <FormItem>
                                <p>发送状态：</p>
                                <Select
                                  id="basic-demo"
                                  defaultValue="all"
                                  style={{ marginTop: '20px', width: '95%' }}
                                  aria-label="name is"
                                  name="sendStatus"
                                  className={styles.select}
                                  followTrigger
                                  // popupProps={popupProps}
                                >
                                  <Option value="all">全部</Option>
                                  <Option value="1">发送成功</Option>
                                  <Option value="0">发送失败</Option>
                                </Select>
                              </FormItem>
                            </div>
                          </div>
                          <div className={styles.CheckButtonBox} style={{ flex: 1 }}>
                            <FormItem>
                              <div style={{ display: 'flex' }}>
                                <Form.Submit
                                  validate
                                  type="primary"
                                  onClick={(v, e) => {
                                    let tempCurrent = secondCurrentData;
                                    tempCurrent = {
                                      pageNo: 1,
                                      pageSize: 10,
                                      taskId: currentId,
                                      taskType: 'S_CFT2',
                                      startTime: v.sendTime && v.sendTime.length !== 0 ? v.sendTime[0]._d.getTime() : '',
                                      endTime: v.sendTime && v.sendTime.length !== 0 ? v.sendTime[1]._d.getTime() : '',
                                      orderId: v.orderId,
                                      sendStatus: v.sendStatus === 'all' ? '' : v.sendStatus,
                                    };
                                    setSecondCurrentData(tempCurrent);
                                    secondRecordCheck(tempCurrent);
                                  }}
                                  style={{ marginRight: 10 }}
                                >查询
                                </Form.Submit>
                                <Form.Reset onClick={() => {
                                  secondRecordCheck({
                                    pageNo: 1,
                                    pageSize: 10,
                                    taskId: currentId,
                                    taskType: 'S_CFT2',
                                  });
                                  setSecondCurrentData({
                                    pageNo: 1,
                                    pageSize: 10,
                                    taskId: currentId,
                                    taskType: 'S_CFT2',
                                    startTime:  '',
                                    endTime: '',
                                    sendStatus: '',
                                  })
                                }}
                                >重置
                                </Form.Reset>
                              </div>
                            </FormItem>
                          </div>
                        </Form>
                      </div>
                      {/* 催付记录表格 */}
                      <div>
                        <Table dataSource={secondRecord} loading={secondLoading} fixedHeader>
                          <Table.Column title="发送时间" dataIndex="sendTime" align="left" />
                          <Table.Column title="订单号" dataIndex="orderId" align="left" />
                          <Table.Column
                            title="字数/计费（条)"
                            dataIndex="smsWordsNum"
                            align="left"
                            cell={(value) => {
                              return (<span>{value.slice(0, value.length - 1)}<span
                                className={styles.mustFill}
                              >{value.slice(value.length - 1)}
                              </span>
                              </span>);
                            }}
                          />
                          <Table.Column
                            title="发送状态"
                            dataIndex="sendStatus"
                            align="left"
                            cell={(value) => {
                              if (value === '发送成功') {
                                return (<div
                                  style={{ color: '#00BB66' }}
                                >{value}
                                </div>);
                              } else if (value === '发送失败') {
                                return (<div
                                  style={{ color: '#FF3333' }}
                                >{value}
                                </div>);
                              }
                            }}
                          />
                          <Table.Column title="催付类型" dataIndex="type" align="left" />
                          <Table.Column 
                            title="备注" 
                            align="left" 
                            cell={(item,value,index)=>(
                              <span>{item.remark?item.remark:'--'}</span>
                            )} 
                          />
                        </Table>
                      </div>
                      <div style={{}}>
                        <LzPagination pageInfo={secondPageInfo} onChange={secondSizeChange} />
                      </div>
                    </div>
                  </Tab.Item>
                </Tab>
              </div>
            </div>
          </div>
        </Dialog>
      }
    </div>
  );
};

export default OrderPaymentList;
